export * from './copy-to-clipboard.component';
